import React, {Component} from 'react';
import {connect} from 'react-redux';
import {DocumentTitle, Page} from '../widgets';
import Form from '../widgets/FormV2';
import sessionActions from '../user/session.actions';
import FancyButton from '../widgets/FancyButton';
import uiActions from '../chrome/ui.actions';
import {push} from 'connected-react-router';
import PickerField from './PickerField';
import getGettingStartedProgress from './gettingStartedProgress';
import fetchJson, {postJson} from '../fetchJson';
import './GettingStarted.css';
import {GettingStartedFooter} from './GettingStarted';
import handleError from '../handleError';

const getSessionProvider = props => props && props.currentSession && props.currentSession.provider;
const getSessionUser = props => props && props.currentSession && props.currentSession.user;

const stateHasChanged = (a, b) => a.about !== b.about || a.brief !== b.brief;

const getStateFromSession = (sessionUser, sessionProvider) =>
	sessionUser && sessionProvider
		? {
				about: sessionProvider.profile.about,
				brief: sessionProvider.profile.brief
		  }
		: {
				about: null,
				brief: null
		  };

const getDataFromState = (state, props) => ({
	user: {
		location: (getSessionUser(props) || {location: null}).location
	},
	profile: {
		about: state.about,
		brief: state.brief
	},
	category: (getSessionProvider(props) || {category: null}).category
});

class GettingStartedBio extends Component {
	constructor(props) {
		super(props);

		this.state = getStateFromSession(getSessionUser(props), getSessionProvider(props));

		this.setAbout = e => this.setState({about: e.target.value});
		this.setBrief = e => this.setState({brief: e.target.value});
		this.showLocationPicker = () => this.props.showLocationPicker(() => null);

		this.next = () => this.props.next(getDataFromState(this.state, this.props));
		this.previous = () => this.props.previous(getDataFromState(this.state, this.props));
	}

	componentWillUpdate(nextProps) {
		if (nextProps.currentSession !== this.props.currentSession) {
			const newState = getStateFromSession(
				getSessionUser(nextProps),
				getSessionProvider(nextProps)
			);
			const oldState = getStateFromSession(
				getSessionUser(this.props),
				getSessionProvider(this.props)
			);
			// Only override state if the values we care about changed upstream
			if (stateHasChanged(oldState, newState)) {
				this.setState(newState);
			}
		}
	}

	render() {
		if (!getSessionProvider(this.props)) return null;

		const progress = getGettingStartedProgress(
			getSessionUser(this.props),
			getSessionProvider(this.props)
		);

		const {showCategoryPicker} = this.props;
		const {about, brief} = this.state;
		const {location} = getSessionUser(this.props) || {};
		const {category} = getSessionProvider(this.props) || {};

		return (
			<DocumentTitle title="B2Me">
				<Page className="GettingStarted scroll-anchor">
					<Form>
						<p>Nearly there! We need just a few more details to finish setting up your page.</p>

						<div>
							<label>
								<h3>Category</h3>
								<PickerField
									value={category}
									onClick={showCategoryPicker}
									placeholder="Choose category →"
								/>
							</label>
						</div>
						<div>
							<label>
								<h3 ref={el => (this.elLocation = el)}>Location</h3>
								<PickerField
									value={location && location.suburb}
									onClick={this.showLocationPicker}
									placeholder="Choose location →"
								/>
							</label>
						</div>
						<div>
							<label>
								<h3>Brief</h3>
								<textarea
									spellCheck={true}
									maxLength={140}
									className="ProfileEditDetails-brief small"
									placeholder="Enter a short summary of you / your business"
									value={brief}
									onChange={this.setBrief}
								/>
								<div className="ProfileEditDetails-brief-counter">
									{(brief || '').length} / 140 characters
								</div>
							</label>
						</div>
						<div>
							<label>
								<h3>About you</h3>
								<textarea
									spellCheck={true}
									maxLength={10000}
									className="ProfileEditDetails-about"
									placeholder="Enter more details about you or your business. What are your skills? What services do you offer? What are some examples of past experience?"
									value={about}
									onChange={this.setAbout}
								/>
							</label>
						</div>
						<GettingStartedFooter
							progress={progress}
							subscriptionLevel={'essential'}
							next={this.next}
							previous={this.previous}
						/>
					</Form>
				</Page>
			</DocumentTitle>
		);
	}
}

const ConnectedGettingStartedBio = connect(
	({session, categories}) => ({
		categories: categories && categories.provider,
		currentSession: session && session.current
	}),
	dispatch => ({
		showLocationPicker: callback => {
			dispatch(
				uiActions.uiPickerCallback(value => {
					dispatch(
						sessionActions.sessionUpdateCurrentProvider({
							user: {location: value}
						})
					);
					dispatch(uiActions.uiModal(null));
					callback(value);
				})
			);
			dispatch(uiActions.uiModal('location-picker'));
		},
		showCategoryPicker: () => {
			dispatch(
				uiActions.uiPickerCallback(value => {
					dispatch(sessionActions.sessionUpdateCurrentProvider({category: value}));
					dispatch(uiActions.uiModal(null));
				})
			);
			dispatch(uiActions.uiModal('category-picker'));
		},
		previous: data => {
			dispatch(sessionActions.persistSessionField(data));
			dispatch(push('/getting-started'));
		},
		next: data => {
			dispatch(sessionActions.persistSessionField(data));
			dispatch(push('/getting-started-community')); // TODO depends on if signing up with a community or not
		},
		handleError: handleError(dispatch)
	})
)(GettingStartedBio);

export default ConnectedGettingStartedBio;



// WEBPACK FOOTER //
// ./src/profile/GettingStartedBio.js